import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FaUser, FaEnvelope } from "react-icons/fa";
import { FaMobileScreenButton } from "react-icons/fa6";

const ContactComponent = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [submissionStatus, setSubmissionStatus] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^[0-9]*$/.test(value)) return;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!/^[0-9]{10}$/.test(formData.phone))
      newErrors.phone = "Enter a valid 10-digit phone number";
    if (!/^([a-zA-Z0-9._%+-]+)@gmail\.com$/.test(formData.email))
      newErrors.email = "Enter a valid Gmail address (e.g., example@gmail.com)";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    emailjs
      .sendForm(
        "service_46lnrmss",
        "template_0ilr829",
        form.current,
        "0ofxr_Kh6bIHXuglK"
      )
      .then(
        () => {
          setSubmissionStatus("Success! Your message has been sent.");
          setFormData({ name: "", phone: "", email: "" });
          setErrors({});
        },
        (error) => {
          console.error("FAILED...", error.text);
          setSubmissionStatus("Failed to send your message. Please try again.");
        }
      );
  };

  return (
    <div className="flex justify-center items-center pt-2 pb-7">
      <div className=" w-full mx-auto p-3">
        <h2 className="text-2xl font-semibold text-gray-800 mb-8 text-center">
          Get in Touch
        </h2>
        <form ref={form} onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
            {errors.name && (
              <p className="text-red-500 text-sm">{errors.name}</p>
            )}
          </div>

          <div className="relative">
            <FaMobileScreenButton className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              maxLength="10"
              className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
            {errors.phone && (
              <p className="text-red-500 text-sm">{errors.phone}</p>
            )}
          </div>

          <div className="relative">
            <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email}</p>
            )}
          </div>
          <div className="flex justify-center">
            <button
              type="submit"
              className="w-72 text-center  mt-4 flex rounded-2xl justify-center items-center px-6 py-1.5 border border-transparent bg-orange-500 text-white font-semibold hover:bg-orange-600 hover:border-white transition duration-300 transform hover:scale-105 active:scale-95"
            >
              Submit
            </button>
          </div>
        </form>
        {submissionStatus && (
          <p
            className={`mt-4 ${
              submissionStatus.includes("Success")
                ? "text-green-500"
                : "text-red-500"
            }`}
          >
            {submissionStatus}
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactComponent;
